<template lang='pug'>
  v-container.pa-0
    v-snackbar(v-model="imageSnackbar" color="red" top)
      | El archivo subido no es una imagen
      template(v-slot:action="{ attrs }")
        v-btn(color="white" text="" v-bind="attrs" @click="imageSnackbar = false")
          | Cerrar
    v-row(:class="isMobile ? 'create-shop__container--mobile' : ''").create-shop__container.mx-0
      v-col(v-if="!isMobile" cols='3' style="position: relative").create-shop.pt-0.mt-0
        v-layout.overlay-content
          .overlay-content__title.ma-auto.text-center.text-uppercase(:class="model.id ? 'overlay-content__title--update' : ''") {{ model.id ? 'Actualizar' : 'Crear' }} Tienda
          .overlay-content__footer
            v-img(src="@/assets/logo-2-w.png" width="100px").ma-auto
      v-col(cols='12' md="9").pa-6
        v-dialog( persistent  :value='validatorRestrictions'  max-width='500px')
          div(style ='position:relative; height: 100%;')
            validate-restrictions(:data="dataValidator" @close="validatorRestrictions=false")
        v-dialog( persistent  :value='validatorRestrictionsStatus'  max-width='500px')
          div(style ='position:relative; height: 100%;')
            validate-restrictions(:data="dataValidatorStatus" @close="validatorRestrictionsStatus=false")
        v-col(class="inputGroupClass")
          v-row(v-show="!isMobile").align-self-center
            v-col(cols="12")
              span.d-block.font-weight-bold Adjuntar imagen
            v-col(cols="7" md="4")
              input.d-none(ref="file" type="file" @change="handleImageUpload" accept='image/*')
              v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="model.pictures.imageInput1 ? 'success--text' : 'grey--text'" outlined="" height="150" width="150" @click="$refs.file.click()")
                v-img(v-if="model.pictures.imageInput1" contain max-height='150px' name='image', :src='model.pictures.imageInput1')
                v-icon.mx-auto(v-else size="120")
                  | mdi-store
            v-col(cols="4")
              v-btn(small color='#00b6bd' rounded @click="pickFile('imageInput1')") Adjuntar
            input(type='file', style='display: none', ref='imageInput1', @change="handleImageUpload" accept='image/*')
            v-progress-circular(v-show='imageLoading' :size='70', :width='7', color='purple', indeterminate='')
          v-row.py-xs-0
            template(v-if="isMobile")
              v-col(cols="5").text-center
                .create-shop__upload-img(v-show="isMobile" @click="$refs.file.click()")
                  v-img(v-if="model.pictures.imageInput1" height='6rem' width="6rem" name='image', :src='model.pictures.imageInput1' style="border-radius: 50%;")
                  v-icon(v-else size="60" color="white").mt-3
                    | mdi-store
              v-col(cols="7")
                v-text-field(  label='Nombre de la Tienda'  type="text", v-model='model.name')
            v-col(v-else cols="12" md="6" lg="6" xl="6").my-0.py-0
              v-text-field(  label='Nombre de la Tienda'  type="text", v-model='model.name')
            v-col(cols="12" md="6" lg="6" xl="6").my-0.py-0
              v-text-field(  label='Teléfono'  type="number", v-model='model.phone')
          v-row
            v-col(cols="12" md="6" lg="6" xl="6").my-0.py-0
              v-text-field( label='NIT'  type="number", v-model='model.ref_id')
            v-col(cols="12" md="6" lg="6" xl="6").my-0.py-0
              v-text-field(  label='Dirección'  type="text", v-model='model.address')
            v-col(cols="12" v-if="!isMobile").my-0.py-0
              h3(style="color: #E0E0E !important;").mdtext--light Categorías
            v-col(cols="12").my-0.py-0
              v-select(:items='mainCategories', item-text='data' return-object label='Categoría principal' v-model="model.mainCategorieSelect")
            v-col(cols="12" v-if="model.mainCategorieSelect && !loadingpresets").my-0.py-0.align-self-center
                v-tooltip(top)
                  template(v-slot:activator="{ on }")
                    v-btn(small color="#00b6bd" rounded v-on="on" @click="openCategoryModal") Crear Subcategoria
                      v-icon.ml-1 mdi-plus
                  span Puedes crear nuevas subcategorias
                v-tooltip(top)
                  template(v-slot:activator="{ on }")
                    v-icon.ml-2(fab icon color="primary" dark="" v-on="on") mdi-alert-circle-outline
                  span Las siguientes subcategorías se mostrarán dentro de tu punto de venta y tienda virtual.
            v-col(cols="12" v-if="model.mainCategorieSelect && !loadingpresets").my-0.py-0
              v-select(v-model='model.categories', :items='allsubcats', return-object  item-text='name' label='Selecciona las subcategorias', multiple='', chips='', hint='Se mostraran en tu punto de venta y tienda virtual', persistent-hint='')
            v-skeleton-loader(v-if="loadingpresets" type="list-item" style="width: 100%;")
          v-row.mt-4.text-center
            v-col(cols="6")
              v-btn(rounded link @click="cancel()") Cancelar
            v-col(cols="6")
              v-btn(color='#008e95' rounded @click='save' :loading="loading" :disabled='!model.name || !model.address || !model.phone || loadingpresets')
                | GUARDAR
        v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' center :timeout='snackbar.timeout' :top="true")
          | {{ snackbar.text }}
          v-btn(dark='' text='' @click='snackbar.snackbar = false')
            | {{$t('payment.general.close')}}
</template>
<script>
  // import Preview from './Preview';
  import * as firebase from 'firebase'
  // import * as vars from '@/vars.json'

  import imageCompression from 'browser-image-compression'

  export default {
    components: {
      // Preview: Preview,
      ValidateRestrictions: () => import('@/views/pages/components/ValidateRestrictions'),
    },
    props: {
      categorySelected: {
        type: String,
        default: '',
      },
      model: Object,
      verification: Object,
      field: Object,
      context: String,
      onSave: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        mainCategories: [],
        dataValidator: {
          title: this.$t('shop.createModule.titleValiadtorShop'),
          message: this.$t('shop.createModule.messageValidatorShop'),
        },
        dataValidatorStatus: {
          title: this.$t('shop.createModule.titleValiadtorShopStatus'),
          message: this.$t('shop.createModule.messageValidatorShopStatus'),
        },
        validatorRestrictions: false,
        validatorRestrictionsStatus: false,
        salePointRestriction: null,
        status: null,
        totalShops: 0,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
        imageSnackbar: false,
        loadingpresets: false,
        allsubcats: [],
      }
    },
    computed: {

      user () {
        return this.$store.state.users.user
      },
      categories () {
        return this.$store.getters['categories/getItems']
      },
      sliderValue () {
        return this.slider
      },
      loading () {
        return this.$store.getters['shops/getLoading']
      },

    },
    watch: {
      'model.mainCategorieSelect' (newVal, oldVal) {
        const vm = this
        // console.log(newVal)
        vm.getSubcategories(newVal)
      },
    },
    mounted () {
      this.onResize()
      const vm = this
      if (this.verification) {
        if (this.verification.addNew) {
          firebase.database().ref(`users/${vm.user.uid}/shops`).on('value', (snapshot) => {
            const res = snapshot.val()
            vm.totalShops = 0
            if (res) {
              const arr = Object.keys(res).map(card => {
                return { id: card, data: res[card] }
              })
              vm.totalShops = arr.length
            }
            this.$store.dispatch('users/getRestrictions').then(res => {
              // console.log(res)
              if (res) {
                vm.salePointRestriction = res.restrictions.salePoints
                vm.status = res.status.val
                if (vm.status !== 'active') {
                  vm.validatorRestrictionsStatus = true
                  return
                }
                if (vm.salePointRestriction === null) {
                  vm.validatorRestrictions = true
                  return
                }
                if (vm.salePointRestriction <= vm.totalShops) {
                  vm.validatorRestrictions = true
                }
              } else {
                vm.validatorRestrictionsStatus = true
              }
            }, rej => {
              this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
            })
          }, (error) => {
            console.log(error)
            vm.setDataNotification(true, 'error', vm.$t('shop.createModule.errorGetRestriction'))
          })
        }
      }
    },
    created () {
      // console.log(this.model, 'i am the model')
      this.$store.dispatch('shops/getMainCategories', 'en').then(res => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          this.mainCategories = categories
        }
      }).finally(() => {
        // console.log('me ejecute maincat 1')
        const initialCategory = vm.mainCategories.find(category => category.data === vm.categorySelected)
        // console.log('me ejecute maincat 2', initialCategory)
        if (initialCategory) {
          // console.log('me ejecute maincat 3')
          vm.model.mainCategorieSelect = initialCategory
        }
      })
      const vm = this
      vm.$store.dispatch('categories/loadItems', 'categories').then(() => {})
      if (vm.model.mainCategorieSelect) {
        vm.getSubcategories(vm.model.mainCategorieSelect)
      }
    },
    methods: {
      getSubcategories (mainCat) {
        const vm = this
        vm.loadingpresets = true
        vm.$store.dispatch('categories/getSubcategories', { data: mainCat }).then(res => {
          vm.loadingpresets = false
          if (res) {
            res.forEach(function (element, i) {
              const found = vm.categories.find(el => el.id === element.id)
              if (found) {
                res.splice(i, 1)
              }
            })
            vm.allsubcats = res.concat(vm.categories)
          }
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      openCategoryModal () {
        this.$emit('openCategoryModal')
      },
      cancel () {
        this.$emit('cancel')
      },
      save () {
        const vm = this
        if (vm.model.mainCategorieSelect) {
          if (vm.verification) {
            if (vm.verification.addNew) {
              if (!vm.status && vm.totalShops < 1) {
                // vm.model.status = 'inactive'
                vm.onSave()
                // vm.loading = false
                vm.$forceUpdate()
                return
              }
              if (vm.status !== 'active') {
                vm.validatorRestrictionsStatus = true
                return
              }
              if (vm.salePointRestriction === null) {
                vm.validatorRestrictions = true
                return
              }
              if (vm.salePointRestriction <= vm.totalShops) {
                vm.validatorRestrictions = true
                return
              }
              vm.onSave()
              vm.$forceUpdate()
            } else {
              vm.onSave()
              vm.$forceUpdate()
            }
          } else {
            vm.onSave()
            vm.$forceUpdate()
          }
        } else {
          vm.setDataNotification(true, 'error', 'Debe agregar la categoría principal para continuar.')
        }
      },
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      onAudioPicked (event) {
        const vm = this
        const files = event.target.files

        const filename = files[0].name

        if (filename.lastIndexOf('.') <= 0) {
          return alert('Agrega un archivo valido')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('loadstart', () => {
          vm.audioLoading = true
        })
        fileReader.addEventListener('loadend', function () {
          vm.audioLoading = false
          // console.log('acabo de subir el archivo de audio')
          vm.setAudio(fileReader.result)
          // console.log(fileReader.result)
        })
        fileReader.readAsDataURL(files[0])
      },
      onImagePicked (event) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/shops`).push().key
        const metadata = {
          contentType: event.target.files[0].type,

          customMetadata: {
            targetType: event.target.files[0].type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/shops/pictures/${vm.model.id}/imageInput1`).put(event.target.files[0], metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.pictures.imageInput1 = url
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/shops`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/shops/pictures/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            // console.log(url)
            vm.model.pictures.imageInput1 = url
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      async handleImageUpload (event) {
        const vm = this
        const imageFile = event.target.files[0]
        if (imageFile.type.includes('image')) {
          // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
          // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

          const options = {
            maxSizeMB: 0.07,
            maxWidthOrHeight: 200,
            useWebWorker: true,
            maxIteration: 15,
          }
          try {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile)
            } // if original is smaller
          } catch (error) {
            // console.log(error)
          }
        } else {
          vm.imageSnackbar = true
        }
      },
      setAudio (audio) {
        this.model.audio = audio
        this.$forceUpdate()
      },
      setImage (ref, image) {
        // console.log(ref)
        this.model.pictures[ref] = image
        // console.log(this.model)
        this.$forceUpdate()
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;
  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{

    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;

    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{

      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }
  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }
  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }
  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }
  .v-input--slider{
    margin-top:0;
  }
  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }
  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }
  .create-shop {
    &__container {
      border-radius: 5px;
      background: #fff;
      box-shadow: 0 1.5rem 4rem rgba(#000, .15);

      &--mobile {
        border-top-left-radius: 75px;
      }
    }

    &__upload-img {
      height: 6rem;
      width: 6rem;
      border-radius: 50%;
      background: #b2b9c0;
    }
    background-image: url('../../../assets/images/background-tender.png');
    padding: 0;
    h3 {
      color: white;
      font-size: 3rem;
      position: absolute;
      text-align: center;
      top: 30%;
      border-bottom: 5px;
      text-transform: uppercase;
    }
    border-radius: 2%;

    &--mobile {
      background:#358f94;
      color: #fff;
      margin: 0;
      text-transform: uppercase;

      &__title {
        font-size: 2rem;
        font-weight: 100;
        margin-left: 1rem;

        &--black {
          font-size: 2rem;
          font-weight: 900;
          margin-left: 1rem;
        }
      }
    }
  }
  .overlay-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: #00CAE3;
    background: linear-gradient(19deg,rgba(#008e95, 0.6) 0%, rgba(#00CAE3, 0.6) 100%);
    &__title {
      line-height: 2.5rem;
      max-width: 140px;
      border-bottom: 3px solid #FFF;
      display: flex;
      position: absolute;
      font-size: 2.5rem;
      font-weight: 800;
      color: white;
      left: 0;
      right: 0;
      margin: auto;
      padding-bottom: 1rem;
      @media (max-width: 900px) {
        font-size: 2rem;
      }
      &--update {
        font-size: 1.8rem;
        padding-bottom: 0.5rem;
      }
    }
    &__footer {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
</style>
